import { AnchorHTMLAttributes, PropsWithChildren } from 'react';

type TNewTabOpenerProps = {
  href: string;
  className?: string;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

function NewTabOpener({
  href,
  children,
  className,
  ...props
}: PropsWithChildren<TNewTabOpenerProps>): JSX.Element {
  return (
    <a
      {...props}
      className={className}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}

export default NewTabOpener;
